rs.module("fund/configuration/insuranceratetiers/index",

    [
        "controls/components/event-banner",
        "common/select-helper",
        "common/visibility"
    ],

    function (eventBanner, selectHelper, visibility) {

        var _executeSelectionChanged;
        var _criteria;

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, grid) {
            _criteria = $.js(jsSelectors.criteria);
            var insuranceRateTierAddButton = _criteria.js(jsSelectors.insuranceRateTierAddButton);
            var insuranceRateTierTypeCard = _criteria.js(jsSelectors.insuranceRateTierTypeCard);
            var insuranceRateTierAddNameForm = _criteria.js(jsSelectors.insuranceRateTierAddNameForm);
            var insuranceRateTierKey = _criteria.js(jsSelectors.insuranceRateTierKey);
            var insuranceRateTierAddNameInput = _criteria.js(jsSelectors.insuranceRateTierAddNameInput);
            var insuranceRateTierTypePartialView = _criteria.js(jsSelectors.insuranceRateTierTypePartialView);

            // On rate tier grid selection change, we will update the rate tier text box
            grid.selectionChanged(function (values, rows) {
                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {
                    //loadRateTier// Retrieve new form data
                    $.get(
                        backendUrls.loadRateTier,

                        { insuranceRateTierKey: values[0] })

                        .done(function (data) {

                            visibility.show(insuranceRateTierAddNameForm);
                            insuranceRateTierKey.val(data.insuranceRateTierKey);
                            insuranceRateTierAddNameInput.val(data.insuranceRateTierName);
                            LoadRateTierTypePartialView(values[0]);
                        });

                    clearBanner();
                }

                _executeSelectionChanged = true;
            });

            //Load the Tier Type based on Rate Tier selection
            function LoadRateTierTypePartialView(insuranceRateTierKey) {
                $.get(backendUrls.loadRateTierTypePartialView,
                    { insuranceRateTierKey: insuranceRateTierKey })
                    .done(function (result) {
                        insuranceRateTierTypePartialView.html(result);
                        _resetValidations();
                    });
                visibility.show(insuranceRateTierTypeCard);
            }

            //Handle clearing out page to add a new Rate Tier
            insuranceRateTierAddButton.click(function () {
                clearBanner();
                visibility.hide(insuranceRateTierTypeCard);
                visibility.show(insuranceRateTierAddNameForm);
                grid.selectedValues = null;
                insuranceRateTierKey.val(-1);
                insuranceRateTierAddNameInput.val('');
            });

            // Clear the event banner of all messages.
            function clearBanner() {
                eventBanner.removeErrorMessages();
                eventBanner.removeInformationalMessages();
            }
        }

        ///
        /// Resets unobtrusive validations, which is required after enabling previously disabled fields.
        ///
        function _resetValidations() {
            var form = _criteria;
            $.validator.resetValidation(form);
        }

        var exports = {
            initialize : initialize
        };

        return exports;
    }

)